import ProTable from './ProTable'
export default ProTable
